import { render } from "./IndexAlgorithmMangerView.vue?vue&type=template&id=5c495957&scoped=true"
import script from "./IndexAlgorithmMangerView.vue?vue&type=script&lang=js"
export * from "./IndexAlgorithmMangerView.vue?vue&type=script&lang=js"

import "./IndexAlgorithmMangerView.vue?vue&type=style&index=0&id=5c495957&scoped=true&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c495957"]])

export default __exports__